/**
 * OTP: resend and verify. Shared by v1–v3 + features OTP UIs.
 *
 * Consumer map:
 *   - `getSendOtpByCustomerIdPath` / `requestOtpResendGet` / `postVerifyOtp`
 *     → `OTPVerificationSheetContent` under each app UI version (`version1|2|3/auth/`).
 *   - Sheet mount: skip auto `requestOtpResendGet` when `context === 'signup'` or `skipInitialResend` (register already sent OTP).
 */
import { apiGet, apiPost } from '../../api/client';
import { endpoints } from '../../config/endpoints';

export function getSendOtpByCustomerIdPath(customerId: number): string {
  return `${endpoints.sendOTP}?customer_id=${customerId}`;
}

export function requestOtpResendGet(customerId: number): Promise<unknown> {
  return apiGet<unknown>(getSendOtpByCustomerIdPath(customerId));
}

export type PostVerifyOtpParams = {
  phone: string;
  country_iso_code: string;
  customer_id: number;
  otp: string;
};

export function postVerifyOtp(params: PostVerifyOtpParams): Promise<unknown> {
  return apiPost<unknown>(endpoints.verifyOTP, params);
}
